import { render, staticRenderFns } from "./RetailersMap.vue?vue&type=template&id=06d354da&scoped=true&"
import script from "./RetailersMap.vue?vue&type=script&lang=js&"
export * from "./RetailersMap.vue?vue&type=script&lang=js&"
import style0 from "./RetailersMap.vue?vue&type=style&index=0&id=06d354da&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d354da",
  null
  
)

export default component.exports